import React from "react";
import CookieConsent from "react-cookie-consent";

export function CommonCookieConsent() {
    return <CookieConsent buttonText="Akzeptieren" expires={60}>Diese Webseite nutzt Cookies.</CookieConsent>
}

